"use client"

type Season = 'spring' | 'summer' | 'autumn' | 'winter';

export default function Background() {
  const getCurrentSeason = (): Season => {
    const month = new Date().getMonth() + 1;
    
    if (month >= 3 && month <= 5) return 'spring';
    if (month >= 6 && month <= 8) return 'summer';
    if (month >= 9 && month <= 11) return 'autumn';
    return 'winter';
  };

  const seasonImages: Record<Season, string> = {
    spring: '/images/universal/bg-spring.jpg',
    summer: '/images/universal/bg-summer.jpg',
    autumn: '/images/universal/bg-autumn.jpg',
    winter: '/images/universal/bg-winter.jpg'
  };

  const currentSeason = getCurrentSeason();
  const backgroundImage = seasonImages[currentSeason];

  return (
    <>
      <div className="fixed top-0 right-0 h-screen w-full overflow-hidden z-[-1]">
        <div
          className="absolute inset-0 bg-cover bg-center w-full"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
          }}
        ></div>
        <div className="w-full overflow-hidden absolute inset-0 bg-gradient-to-b from-white via-white/50 to-white"></div>
      </div>
    </>
  );
}